module.exports = __webpack_public_path__ + "static/media/hamburgerBlack.b3523f6e.svg";